import { useNavigate } from "react-router-dom";
import { ChevronLeft, Cookie } from "lucide-react";

/**
 * Landing shell for the "Пряничная мастерская" space.
 * A separate top-level room from Программы Anokina Studio.
 * Full contents (роспись, домики, глазурь, шаблоны, PDF, стенсили, digital assets…)
 * will be built in a later sprint.
 */
export default function GingerbreadLanding() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col"
         style={{ background: "linear-gradient(180deg, #FBEEDA 0%, #F5E1BF 100%)" }}
         data-testid="gingerbread-landing-page">
      <header className="flex items-center gap-3 px-5 pt-5 pb-3 max-w-4xl mx-auto w-full">
        <button
          onClick={() => nav("/hall")}
          data-testid="back-to-hall-button"
          className="p-2 -ml-2 rounded-full hover:bg-white/50"
          aria-label="В главный зал"
        >
          <ChevronLeft className="w-5 h-5 text-espresso" />
        </button>
        <div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-[#8B6A3F]">
            Anokina Studio · Мастерская
          </div>
          <h1 className="font-serif text-2xl text-espresso -mt-0.5" data-testid="gingerbread-title">
            Пряничная мастерская
          </h1>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="max-w-xl w-full text-center rounded-3xl bg-white/85 backdrop-blur border border-[#DDB98A]/60 px-8 py-12">
          <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl border border-[#DDB98A]/60 bg-[#FBEEDA] text-[#B8804A] mb-5">
            <Cookie className="w-6 h-6" strokeWidth={1.6} />
          </span>
          <h2 className="font-serif text-3xl text-espresso leading-tight">Скоро</h2>
          <p className="text-sm text-muted-foreground mt-3 leading-relaxed">
            Здесь появятся уроки по росписи, пряничные домики, техники глазурования, шаблоны, PDF, стенсили и цифровые материалы для мастерской.
          </p>
          <p className="text-xs text-muted-foreground/80 mt-6 uppercase tracking-widest">
            Пространство мастерской
          </p>
        </div>
      </div>
    </div>
  );
}
